import { DriveFileMoveOutlined as DriveFileMoveIcon } from '@mui/icons-material';
import {
  Box,
  Divider as MuiDivider,
  Grid,
  styled,
  Tab as MuiTab,
  Tabs as MuiTabs,
  Typography,
} from '@mui/material';

export const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 25px;
  maxheight: 'calc(100vh - 120px)';
`;

export const Tabs = styled(MuiTabs)(
  ({ theme }) => `
  border-bottom: 1px solid ${theme.palette.brand.charcoal};
`,
);

export const Tab = styled(MuiTab)(
  ({ theme }) => `
  text-transform: none;
  white-space: pre-wrap;
  &.Mui-selected {
    color: ${theme.palette.secondary.dark};
  }
`,
);

export const Divider = styled(MuiDivider)(
  ({ theme, $marginBottom }) => `
  color:${theme.palette.brand.charcoal};
  margin-top:10px;
  margin-bottom: ${$marginBottom}px;
`,
);

export const SubHeader = styled(Typography)(
  () => `
  font-size: 1rem;
  font-weight: 400;
`,
);

export const SubHeaderText = styled(Typography)(
  ({ theme }) => `
  font-size: 16px;
  font-weight: 300;
  color: '${theme.palette.brand.black}';
`,
);

export const Content = styled(Grid)`
  display: flex;
  justify-content: space-between;
`;

export const Section = styled(Grid)`
  overflow-y: auto;
  padding: 20px;
  &::-webkit-scrollbar {
    width: 0px;
  }
`;

export const Footer = styled(Grid)`
  display: flex;
  justify-content: end;
  align-items: end;
  gap: 10px;
  position: fixed;
  bottom: 10px;
  right: 20px;
`;

export const OOTagsContainer = styled(Box)`
  margin-top: 10px;
`;

export const ChipSpacer = styled(Box)`
  margin: 0 5px 5px 0;
  display: inline-block;
`;

export const StyledItem = styled(Grid)`
  max-height: calc(100vh - 120px);
  overflow-y: scroll;
  &::-webkit-scrollbar {
    width: 0px;
  }
  margin-top: 10px;
`;

export const StyledBorder = styled(Grid)(({ theme }) => ({
  border: `1px solid ${theme.palette.grey[100]}`,
  borderTopLeftRadius: 10,
  borderTopRightRadius: 10,
  height: 'inherit',
}));

export const ChannelGridContainer = styled(Grid)({
  height: 'calc(100vh - 190px)',
  overflowY: 'scroll',
  '&::-webkit-scrollbar': {
    width: '0px',
  },
  marginTop: '42px',
  width: '75%',
});

export const StyledGridHeader = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  padding: '8px 10px',
  position: 'sticky',
  top: 0,
  zIndex: 1,
  border: `1px solid ${theme.palette.grey[100]}`,
  borderTopLeftRadius: 10,
  borderTopRightRadius: 10,
}));

export const LocationGroupLinkText = styled('div')`
  overflow: hidden;
`;

export const LocationGroupLink = styled(Typography)(
  ({ theme }) => `
  font-size: 16px;
  font-weight: 300;
  color: ${theme.palette.primary.main};
  text-decoration: underline;
  cursor: pointer
`,
);

export const LocationGroupIconContainer = styled(Box)`
  display: flex;
  gap: 16px;
  align-items: center;
`;

export const StyledDriveFileMoveIcon = styled(DriveFileMoveIcon)(
  ({ theme, $isModalOpen }) => `
          color:  ${
            $isModalOpen
              ? `${theme.palette.primary.main}`
              : `${theme.palette.secondary.main}`
          };
          cursor: pointer
      `,
);

export const StoreLocation = styled(Grid)`
  padding-top: 16px !important;
`;
